<template>
  <div ref="subBasin" class="subBasin"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  data() {
    return {
      myChart: {},
    }
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.subBasin)
  },
  methods: {
    initChart(xdata = [], ydata = [], name = '', color = '', unit = '') {
      // initChart() {
      if (this.myChart) {
        this.myChart.clear()
      }
      let option = {
        textStyle: {
          color: "#fff",
        },
        grid: {
          top: 40,
          bottom: 40,
          left: 40,
          right: 10,
        },
        tooltip: {
          show: true,
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          type: "scroll",
          top: 10,
          bottom: 20,
          textStyle: {
            color: "#fff",
            fontSize: 14,
            fontFamily: "PingFang",
          },
        },
        xAxis: {
          type: "category",
          data: xdata,
          axisLabel: {
            show: true, // 是否显示刻度标签，默认显示
            interval: 'auto', // 坐标轴刻度标签的显示间隔，在类目轴中有效；默认会采用标签不重叠的策略间隔显示标签；可以设置成0强制显示所有标签；如果设置为1，表示『隔一个标签显示一个标签』，如果值为2，表示隔两个标签显示一个标签，以此类推。
            // rotate: 30, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠；旋转的角度从-90度到90度
            inside: false, // 刻度标签是否朝内，默认朝外
            margin: 10, // 刻度标签与轴线之间的距离
            // width: 60,
            overflow: "truncate",
          },
          axisLine: {
            lineStyle: {
              color: '#FFFFFF' // 设置x轴线颜色为白色
            }
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: [
          {
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "rgba(255,255,255, 0.1)",
              },
            },
            type: "value",
            name: unit,
            // nameTextStyle: {
            //   fontSize: "16px",
            // },
          },
        ],
        series: [
          {
            name: name,
            data: ydata,
            type: "line",
            smooth: true,
            lineStyle: {
              color,
              // color: "#9281D8",
              // color: "#43C2C3",
            },
            itemStyle: {
              color,
              cap: "round",
              opacity: 1, //为0不绘制折线拐点
            },
          },
        ],
        animationDuration: 1500,
      };
      this.$nextTick(() => {
        this.myChart.setOption(option)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.subBasin {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
</style>
